export default {"src":"/_next/static/media/switch_full_logo.120c5d66.svg","height":50,"width":188};